import { Grid, Typography } from "@mui/material";
import styles from "../css/NavbarItem.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

interface NavbarItemProps {
    index: number;
    headerText: string;
    infoText: string;
    selected: boolean;
    setSelectedIndex: any;
    dataTestId: string;
}

export const NavbarItem = ({index, headerText, infoText, selected, setSelectedIndex, dataTestId}: NavbarItemProps) => {
    const handleClick = () => {
        setSelectedIndex(index);
    };

    return(
        <div className={styles.navbarItemContainer} onClick={handleClick} data-testid={dataTestId}>
            <Grid className={selected ? `${styles.navbarItem} ${styles.selectedNavbarItem}` : styles.navbarItem}>
                <Grid xs={2}>
                    <div className={styles.index}>{index}</div>
                </Grid>
                <Grid xs={8}>
                    <Typography variant="h3" className={styles.headerText}>{headerText}</Typography>
                    <Typography variant="body2">{infoText}</Typography>
                </Grid>
                <Grid xs={2}>
                    <FontAwesomeIcon icon={faChevronRight} size="2x"/>
                </Grid>
            </Grid>
        </div>
    )
}